import { FormattedMessage } from 'react-intl'

import { type DiscountTableData } from '../models/types'

export const ExampleDiscountTableData: DiscountTableData[] = [
  {
    header: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.header.0" />
    ),
    key: 'row-0',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.0.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.0.1" />
    ),
  },
  {
    header: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.header.1" />
    ),
    key: 'row-1',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.1.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.1.1" />
    ),
  },
  {
    header: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.header.2" />
    ),
    key: 'row-2',
    row1: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.2.0" />
    ),
    row2: (
      <FormattedMessage id="prescriptionBonus.modal.example.discount.table.row.2.1" />
    ),
  },
]
